export default __webpack_public_path__ + "static/media/Bandipur1.1bc3f8bc.jpg";